// Cookie'max age: 365 days
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

interface Cookie {
  key: string;
  value: string;
  domain?: string;
  path?: string;
}

export function decodeCookie(): any {
  const cookieObj = document.cookie.split(';').reduce(
    (res, c) => {
      const trimmed = c.trim();
      if (!trimmed) return res;
      const firstEq = trimmed.indexOf('=');
      if (firstEq === -1) return res;
      const key = decodeURIComponent(trimmed.slice(0, firstEq));
      const val = decodeURIComponent(trimmed.slice(firstEq + 1));
      const allNumbers = (str: string): boolean => /^\d+$/.test(str);
      try {
        return Object.assign(res, {
          [key]: allNumbers(val) ? val : JSON.parse(val),
        });
      } catch (e) {
        return Object.assign(res, { [key]: val });
      }
    },
    {} as Record<string, any>
  );

  if (
    !cookieObj.token ||
    cookieObj.token === 'undefined' ||
    cookieObj.token === 'null'
  ) {
    try {
      const storedToken = window.localStorage.getItem('token');
      if (
        storedToken &&
        storedToken !== 'undefined' &&
        storedToken !== 'null'
      ) {
        cookieObj.token = storedToken;
      }
    } catch (e) {
      // ignore
    }
  }

  return cookieObj;
}

function isHttps(): boolean {
  return window.location.protocol === 'https:';
}

export function encodeCookie({ key, value, domain, path = '/' }: Cookie): void {
  try {
    if (value && value !== 'undefined' && value !== 'null') {
      window.localStorage.setItem(key, value);
    } else {
      window.localStorage.removeItem(key);
    }
  } catch (e) {
    // ignore
  }

  let finalCookieValue = `${key}=${encodeURIComponent(
    value || ''
  )};max-age=${COOKIE_MAX_AGE};SameSite=Lax`;
  if (isHttps()) finalCookieValue += ';secure';
  if (domain) finalCookieValue += `;domain=${domain}`;
  if (path) finalCookieValue += `;path=${path}`;
  document.cookie = finalCookieValue;
}
